import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

const ENV = import.meta.env.VITE_ENVIRONMENT || 'DEV';

const navItems = [
  { to: '/', label: 'Dashboard', icon: '📊' },
  { to: '/search', label: 'Search Records', icon: '🔍' },
  { to: '/restore/plan', label: 'Restore Plan', icon: '🔄' },
];

export function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Environment Banner */}
      <div
        role="banner"
        aria-label={`${ENV} environment`}
        style={{
          padding: '0.35rem 1rem',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: '0.75rem',
          letterSpacing: '0.05em',
          background: ENV === 'PROD' ? 'var(--color-banner-prod)' : 'var(--color-banner-dev)',
          color: ENV === 'PROD' ? 'var(--color-banner-prod-text)' : 'var(--color-banner-dev-text)',
        }}
      >
        {ENV} ENVIRONMENT
      </div>

      <div style={{ display: 'flex', flex: 1 }}>
        {/* Sidebar Navigation */}
        <nav
          aria-label="Main navigation"
          style={{
            width: 'var(--sidebar-width)',
            background: 'var(--color-surface)',
            borderRight: '1px solid var(--color-border)',
            padding: '1rem 0',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ padding: '0 1rem', marginBottom: '1.5rem' }}>
            <h1 style={{ fontSize: '1rem', margin: 0 }}>SF Backup</h1>
            <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', margin: 0 }}>
              Restore Portal
            </p>
          </div>

          <ul style={{ listStyle: 'none', padding: 0, margin: 0, flex: 1 }}>
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === '/'}
                  style={({ isActive }) => ({
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.6rem 1rem',
                    color: isActive ? 'var(--color-primary)' : 'var(--color-text)',
                    background: isActive ? '#e8f4fd' : 'transparent',
                    borderLeft: isActive ? '3px solid var(--color-primary)' : '3px solid transparent',
                    textDecoration: 'none',
                    fontSize: '0.875rem',
                  })}
                >
                  <span aria-hidden="true">{item.icon}</span>
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* User info and logout */}
          <div
            style={{
              padding: '1rem',
              borderTop: '1px solid var(--color-border)',
              fontSize: '0.8rem',
            }}
          >
            <p style={{ margin: '0 0 0.5rem', color: 'var(--color-text-muted)' }}>
              {user?.email || user?.name || user?.sub || 'User'}
            </p>
            <button
              onClick={logout}
              className="secondary"
              style={{ width: '100%', fontSize: '0.75rem', padding: '0.4rem' }}
            >
              Sign Out
            </button>
          </div>
        </nav>

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            padding: '1.5rem 2rem',
            overflow: 'auto',
          }}
          role="main"
        >
          {children}
        </main>
      </div>
    </div>
  );
}
